import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Filter, Sliders } from "react-feather";
import Select from "react-select";
import { Edit, Globe, Trash2, User } from "react-feather";
// import { useSelector } from "react-redux";
import Table from "../../../core/pagination/datatable";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ImageWithBasePath from "../../img/imagewithbasebath";
import Breadcrumbs from "../../breadcrumbs";
import StoreModal from "./storeModal";
import useStore from "../../../controllers/useStore";
import EditStoreModal from "./editStoreModal";
import usePermissions from "../../hooks/usePermissions";

const StoreList = () => {
  // const data = useSelector((state) => state.customerdata);
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  const [pagination, setPagination] = useState({ pageStart: 0, limit: 10 });
  const {
    values: { allStoreByAdmin, total, loading },
  } = useStore(pagination);

  const handlePageChange = (currentPage, pageSize) => {
    const pageStart = currentPage;
    setPagination({ pageStart, limit: pageSize });
  };

  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];
  const optionsTwo = [
    { label: "Choose Store Name", value: "" },
    { label: "Benjamin", value: "Benjamin" },
    { label: "Ellen", value: "Ellen" },
    { label: "Freda", value: "Freda" },
    { label: "Kaitlin", value: "Kaitlin" },
  ];

  const countries = [
    { label: "Choose Country", value: "" },
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
  ];

  const columns = [
    {
      title: "Store Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Owner",
      dataIndex: "owner",
      sorter: (a, b) => a.owner.full_name.length - b.owner.full_name.length,
      render: (text, record) => record.owner.full_name,
    },

    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.owner.email.length - b.owner.email.length,
      render: (text, record) => record.owner.email,
    },

    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => a.owner.phone.length - b.owner.phone.length,
      render: (text, record) => record.owner.phone,
    },
    ...(canEdit || canDelete
      ? [
          {
            title: "Action",
            dataIndex: "action",
            render: (text, record) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  <div className="input-block add-lists"></div>

                  {/* <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link> */}

                  <Link
                    className="me-2 p-2"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#edit-units"
                    onClick={() => setSelectedRow(record)}
                  >
                    <Edit className="feather-edit" />
                  </Link>

                  <Link
                    className="confirm-text p-2"
                    to="#"
                    onClick={showConfirmationAlert}
                  >
                    <Trash2 className="feather-trash-2" />
                  </Link>
                </div>
              </div>
            ),
            sorter: (a, b) => a.createdby.length - b.createdby.length,
          },
        ]
      : []),
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Store List"
          subtitle="Manage Your Store"
          addButton="Add Store"
          canAdd={canAdd}
        />

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />

                <Select
                  classNamePrefix="react-select"
                  className="img-select"
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        classNamePrefix="react-select"
                        className="img-select"
                        options={optionsTwo}
                        placeholder="Choose Store Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        classNamePrefix="react-select"
                        className="img-select"
                        options={countries}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={allStoreByAdmin?.data || []}
                total={total}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <StoreModal />
      <EditStoreModal rowData={selectedRow} />
    </div>
  );
};

export default StoreList;
